export const toBoolean = (string) => {
  return !!JSON.parse(string.toLowerCase());
};
